module.exports = __webpack_public_path__ + "static/images/homeicon4.6e5b764.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homeicon4.png
// module id = 7s3P
// module chunks = 0